import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import Recs from './recs';
import { tabs } from './config';
import { Style } from './style';
import Widget from '../../widget';
import SupplyChain from './supply-chain';
import useFetchHelper from '../../../../../helpers/useFetchHelper';
import DashboardPopover from '../../../components/Popover';

const ProposedMitigation = ({
  data = null,
  allEvents = [],
  organisationName,
  project,
  language,
}) => {
  const { t } = useTranslation();
  const ref = useRef();
  const [activeKey, setActiveKey] = useState(tabs[0].key);
  const [showSupplyChain, setShowSupplyChain] = useState(false);
  const { canFetch } = useFetchHelper({ ref });

  const _onChange = (key) => {
    if (key === 'supplyChain' && !showSupplyChain) {
      setShowSupplyChain(true);
    }

    setActiveKey(key);
  };

  useEffect(() => {
    if (canFetch) { }
  }, [canFetch]);

  return (
    <div ref={ref} className="flex-row flex-1 mt-w">
      <Widget
        title={t('Proposed Mitigation')}
        header={(
          <div className="flex-row flex-1 end">
            {tabs.map((_t, i) => (
              <Button
                type={activeKey === _t.key ? 'primary' : 'default'}
                onClick={() => _onChange(_t.key)}
                key={`${_t.key}-tabs`}
                className={`${i === tabs.length - 1 ? '' : 'w-mr'} ${activeKey !== _t.key ? 'gray-btn' : ''}`}
              >
                {t(_t.label)}
              </Button>
            ))}
          </div>
        )}
        tooltip={(
          <DashboardPopover
            title={t('Proposed Mitigation')}
            body={t('List of recommendations associated with this supply chain, based on available information sources.')}
          />
        )}
      >
        <Style style={{ display: activeKey !== 'supplyChain' ? 'block' : 'none' }}>
          <Recs
            PmeProjectGetWithFilters={() => { }}
            data={data}
            allEvents={allEvents}
            project={project}
            language={language}
            organisationName={organisationName}
          />
        </Style>
        {showSupplyChain && (
          <Style style={{ display: activeKey === 'supplyChain' ? 'block' : 'none' }}>
            <SupplyChain
              project={project}
              language={language}
            />
          </Style>
        )}
      </Widget>
    </div>
  );
};

export default ProposedMitigation;
